import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

import { environment } from "pstat-anywhere/relay";

const mutation = graphql`
  mutation LoginMutation($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      ok
      reasons
    }
  }
`;

export const doLogin = (username, password, callback) => {
  const variables = {
    username: username,
    password: password
  };

  // TODO decide how to handle errors
  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => {
      callback(response);
    },
    onError: err => console.error(err)
  });
};
